"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLORS = exports.BACKGROUND_COLORS = exports.PADDING_START = exports.PADDING_BOTTOM = exports.PADDING_END = exports.PADDING_TOP = exports.PADDING_Y = exports.PADDING_X = exports.PADDING = exports.MARGIN_START = exports.MARGIN_BOTTOM = exports.MARGIN_END = exports.MARGIN_TOP = exports.MARGIN_Y = exports.MARGIN_X = exports.MARGIN = exports.SHADOW = exports.ROUNDED = exports.BORDER_COLOR = exports.BORDER = exports.DISABLED = void 0;
const Box_module_scss_1 = __importDefault(require("./Box.module.scss"));
exports.DISABLED = Object.freeze({
    DISABLED: Box_module_scss_1.default.opacityDisabled
});
exports.BORDER = Object.freeze({
    DEFAULT: Box_module_scss_1.default.border
});
exports.BORDER_COLOR = Object.freeze({
    UI_BORDER_COLOR: Box_module_scss_1.default.borderColorUiBorderColor,
    LAYOUT_BORDER_COLOR: Box_module_scss_1.default.borderColorLayoutBorderColor
});
exports.ROUNDED = Object.freeze({
    SMALL: Box_module_scss_1.default.roundedSmall,
    MEDIUM: Box_module_scss_1.default.roundedMedium,
    BIG: Box_module_scss_1.default.roundedBig
});
exports.SHADOW = Object.freeze({
    XS: Box_module_scss_1.default.shadowXs,
    SMALL: Box_module_scss_1.default.shadowSmall,
    MEDIUM: Box_module_scss_1.default.shadowMedium,
    LARGE: Box_module_scss_1.default.shadowLarge
});
exports.MARGIN = Object.freeze({
    AUTO: Box_module_scss_1.default.mAuto,
    XS: Box_module_scss_1.default.mXs,
    SMALL: Box_module_scss_1.default.mSmall,
    MEDIUM: Box_module_scss_1.default.mMedium,
    LARGE: Box_module_scss_1.default.mLarge,
    XL: Box_module_scss_1.default.mXl,
    XXL: Box_module_scss_1.default.mXxl,
    XXXL: Box_module_scss_1.default.mXxxl
});
exports.MARGIN_X = Object.freeze({
    AUTO: Box_module_scss_1.default.mxAuto,
    XS: Box_module_scss_1.default.mxXs,
    SMALL: Box_module_scss_1.default.mxSmall,
    MEDIUM: Box_module_scss_1.default.mxMedium,
    LARGE: Box_module_scss_1.default.mxLarge,
    XL: Box_module_scss_1.default.mxXl,
    XXL: Box_module_scss_1.default.mxXxl,
    XXXL: Box_module_scss_1.default.mxXxxl
});
exports.MARGIN_Y = Object.freeze({
    AUTO: Box_module_scss_1.default.myAuto,
    XS: Box_module_scss_1.default.myXs,
    SMALL: Box_module_scss_1.default.mySmall,
    MEDIUM: Box_module_scss_1.default.myMedium,
    LARGE: Box_module_scss_1.default.myLarge,
    XL: Box_module_scss_1.default.myXl,
    XXL: Box_module_scss_1.default.myXxl,
    XXXL: Box_module_scss_1.default.myXxxl
});
exports.MARGIN_TOP = Object.freeze({
    AUTO: Box_module_scss_1.default.mtAuto,
    XS: Box_module_scss_1.default.mtXs,
    SMALL: Box_module_scss_1.default.mtSmall,
    MEDIUM: Box_module_scss_1.default.mtMedium,
    LARGE: Box_module_scss_1.default.mtLarge,
    XL: Box_module_scss_1.default.mtXl,
    XXL: Box_module_scss_1.default.mtXxl,
    XXXL: Box_module_scss_1.default.mtXxxl
});
exports.MARGIN_END = Object.freeze({
    AUTO: Box_module_scss_1.default.meAuto,
    XS: Box_module_scss_1.default.meXs,
    SMALL: Box_module_scss_1.default.meSmall,
    MEDIUM: Box_module_scss_1.default.meMedium,
    LARGE: Box_module_scss_1.default.meLarge,
    XL: Box_module_scss_1.default.meXl,
    XXL: Box_module_scss_1.default.meXxl,
    XXXL: Box_module_scss_1.default.meXxxl
});
exports.MARGIN_BOTTOM = Object.freeze({
    AUTO: Box_module_scss_1.default.mbAuto,
    XS: Box_module_scss_1.default.mbXs,
    SMALL: Box_module_scss_1.default.mbSmall,
    MEDIUM: Box_module_scss_1.default.mbMedium,
    LARGE: Box_module_scss_1.default.mbLarge,
    XL: Box_module_scss_1.default.mbXl,
    XXL: Box_module_scss_1.default.mbXxl,
    XXXL: Box_module_scss_1.default.mbXxxl
});
exports.MARGIN_START = Object.freeze({
    AUTO: Box_module_scss_1.default.msAuto,
    XS: Box_module_scss_1.default.msXs,
    SMALL: Box_module_scss_1.default.msSmall,
    MEDIUM: Box_module_scss_1.default.msMedium,
    LARGE: Box_module_scss_1.default.msLarge,
    XL: Box_module_scss_1.default.msXl,
    XXL: Box_module_scss_1.default.msXxl,
    XXXL: Box_module_scss_1.default.msXxxl
});
exports.PADDING = Object.freeze({
    XS: Box_module_scss_1.default.pXs,
    SMALL: Box_module_scss_1.default.pSmall,
    MEDIUM: Box_module_scss_1.default.pMedium,
    LARGE: Box_module_scss_1.default.pLarge,
    XL: Box_module_scss_1.default.pXl,
    XXL: Box_module_scss_1.default.pXxl,
    XXXL: Box_module_scss_1.default.pXxxl
});
exports.PADDING_X = Object.freeze({
    XS: Box_module_scss_1.default.pxXs,
    SMALL: Box_module_scss_1.default.pxSmall,
    MEDIUM: Box_module_scss_1.default.pxMedium,
    LARGE: Box_module_scss_1.default.pxLarge,
    XL: Box_module_scss_1.default.pxXl,
    XXL: Box_module_scss_1.default.pxXxl,
    XXXL: Box_module_scss_1.default.pxXxxl
});
exports.PADDING_Y = Object.freeze({
    XS: Box_module_scss_1.default.pyXs,
    SMALL: Box_module_scss_1.default.pySmall,
    MEDIUM: Box_module_scss_1.default.pyMedium,
    LARGE: Box_module_scss_1.default.pyLarge,
    XL: Box_module_scss_1.default.pyXl,
    XXL: Box_module_scss_1.default.pyXxl,
    XXXL: Box_module_scss_1.default.pyXxxl
});
exports.PADDING_TOP = Object.freeze({
    XS: Box_module_scss_1.default.ptXs,
    SMALL: Box_module_scss_1.default.ptSmall,
    MEDIUM: Box_module_scss_1.default.ptMedium,
    LARGE: Box_module_scss_1.default.ptLarge,
    XL: Box_module_scss_1.default.ptXl,
    XXL: Box_module_scss_1.default.ptXxl,
    XXXL: Box_module_scss_1.default.ptXxxl
});
exports.PADDING_END = Object.freeze({
    XS: Box_module_scss_1.default.peXs,
    SMALL: Box_module_scss_1.default.peSmall,
    MEDIUM: Box_module_scss_1.default.peMedium,
    LARGE: Box_module_scss_1.default.peLarge,
    XL: Box_module_scss_1.default.peXl,
    XXL: Box_module_scss_1.default.peXxl,
    XXXL: Box_module_scss_1.default.peXxxl
});
exports.PADDING_BOTTOM = Object.freeze({
    XS: Box_module_scss_1.default.pbXs,
    SMALL: Box_module_scss_1.default.pbSmall,
    MEDIUM: Box_module_scss_1.default.pbMedium,
    LARGE: Box_module_scss_1.default.pbLarge,
    XL: Box_module_scss_1.default.pbXl,
    XXL: Box_module_scss_1.default.pbXxl,
    XXXL: Box_module_scss_1.default.pbXxxl
});
exports.PADDING_START = Object.freeze({
    XS: Box_module_scss_1.default.psXs,
    SMALL: Box_module_scss_1.default.psSmall,
    MEDIUM: Box_module_scss_1.default.psMedium,
    LARGE: Box_module_scss_1.default.psLarge,
    XL: Box_module_scss_1.default.psXl,
    XXL: Box_module_scss_1.default.psXxl,
    XXXL: Box_module_scss_1.default.psXxxl
});
exports.BACKGROUND_COLORS = Object.freeze({
    PRIMARY_BACKGROUND_COLOR: Box_module_scss_1.default.bgPrimaryBackgroundColor,
    SECONDARY_BACKGROUND_COLOR: Box_module_scss_1.default.bgSecondaryBackgroundColor,
    GREY_BACKGROUND_COLOR: Box_module_scss_1.default.bgGreyBackgroundColor,
    ALL_GREY_BACKGROUND_COLOR: Box_module_scss_1.default.bgAllgreyBackgroundColor,
    INVERTED_COLOR_BACKGROUND: Box_module_scss_1.default.bgInvertedColorBackground
});
exports.COLORS = Object.freeze({
    PRIMARY_TEXT_COLOR: Box_module_scss_1.default.textPrimaryTextColor,
    TEXT_COLOR_ON_INVERTED: Box_module_scss_1.default.textTextColorOnInverted,
    SECONDARY_TEXT_COLOR: Box_module_scss_1.default.textSecondaryTextColor
});
